const endpoints = {
  ipv4: "https://api.ipify.org",
  ipv6: "https://api6.ipify.org",
};

export default endpoints;
